@use "../../styles/layout";

.mediaGridBlock {
    display: grid;
    grid-template-columns: repeat(layout.$totalColumns, 1fr);
    gap: layout.$gridGap;
}

.mediaGridBlockRow {
    // Each row spans a set number of grid columns (defined by the sum of it's
    // tile widths set in CMS).
    @for $i from 1 through layout.$totalColumns {
        &[data-width="#{$i}"] {
            grid-column: 1 / span $i;
        }
    }

    // The tiles with in the row are laid out with flexbox so that the exact
    // tile widths can be adjusted in-order to make the tile height all match.
    display: flex;
    gap: layout.$gridGap;
}
